import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import {
  COLOR_PARITY_LOSS,
  COLOR_PARITY_WIN,
  getCssVariableValue,
} from 'frontend-utils/utils/css-variable';
import GeneralListsContentCategoryName from 'lumen/components/general/lists/content/category-name';
import GeneralListsContentCategoryOtas from 'lumen/components/general/lists/content/category-otas';
import GeneralListsListIssueCount from 'lumen/components/general/lists/list-issue-count';
import GeneralListsListItemsListItemTotal from 'lumen/components/general/lists/list-items/list-item-total';

interface GeneralListsListItemsListItemParityOverviewSignature {
  Args: {
    isLoading: unknown;
    params: unknown;
  };
}

export default class GeneralListsListItemsListItemParityOverview extends Component<GeneralListsListItemsListItemParityOverviewSignature> {
  colorLoss = getCssVariableValue(COLOR_PARITY_LOSS);
  colorWin = getCssVariableValue(COLOR_PARITY_WIN);

  <template>
    <div class="flex flex-1 justify-between">
      <div class="parity-category-name">
        <GeneralListsContentCategoryName
          @category={{@params}}
          {{! @glint-expect-error: Incorrect type }}
          @isLoading={{@isLoading}}
        />
      </div>
      <div class="parity-category-otas">
        {{! @glint-expect-error: Incorrect type }}
        <GeneralListsContentCategoryOtas @otas={{@params.otas}} />
      </div>
      {{! @glint-expect-error: Incorrect type }}
      {{#if (eq @params.type "win")}}
        <div class="parity-category-total">
          <GeneralListsListItemsListItemTotal
            @backgroundColour={{this.colorWin}}
            {{! @glint-expect-error: Incorrect type }}
            @isLoading={{@isLoading}}
            {{! @glint-expect-error: Incorrect type }}
            @itemTotal={{@params.total}}
            @subText={{t "parity.of_estimated_win"}}
            {{! @glint-expect-error: Incorrect type }}
            @total={{@params.categoryTotal}}
          />
        </div>
      {{else}}
        <div class="parity-category-total">
          <GeneralListsListItemsListItemTotal
            @backgroundColour={{this.colorLoss}}
            {{! @glint-expect-error: Incorrect type }}
            @isLoading={{@isLoading}}
            {{! @glint-expect-error: Incorrect type }}
            @itemTotal={{@params.total}}
            @subText={{t "parity.of_estimated_loss"}}
            {{! @glint-expect-error: Incorrect type }}
            @total={{@params.categoryTotal}}
          />
        </div>
      {{/if}}
      <div class="parity-category-count">
        <GeneralListsListIssueCount
          {{! @glint-expect-error: Incorrect type }}
          @isLoading={{@isLoading}}
          {{! @glint-expect-error: Incorrect type }}
          @itemIssueCount={{@params.issues.length}}
        />
      </div>
    </div>
  </template>
}
